module.exports = __webpack_public_path__ + "static/media/power_settings.e23db89d.svg";